import { filterAttachments } from 'common/api/attachments';

import {
    FETCH_FILTER_ATTACHMENTS,
    FETCH_FILTER_ATTACHMENTS_FAILURE,
    FETCH_FILTER_ATTACHMENTS_SUCCESS,
} from '../actionTypes';
import { attachmentsActions } from '../reducer';

export default (filterData) => (dispatch) => {
    dispatch(attachmentsActions[FETCH_FILTER_ATTACHMENTS]());

    const {
        orderBy,
        page = 0,
        pageSize,
        searchText,
        sortBy,
        status,
    } = filterData;

    filterAttachments({
        orderBy,
        page: page + 1,
        perPage: pageSize,
        searchText,
        sortBy,
        status,
    })
        .then((response) =>
            dispatch(
                attachmentsActions[FETCH_FILTER_ATTACHMENTS_SUCCESS](
                    response.data,
                ),
            ),
        )
        .catch((error) =>
            dispatch(
                attachmentsActions[FETCH_FILTER_ATTACHMENTS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
